var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'has-user-mobile-nav': _vm.showUserMobileNav },attrs:{"id":"app"}},[_c('router-view'),(_vm.showUserFooter)?_c('apoc-record-bar'):_vm._e(),(_vm.showUserMobileNav)?_c('user-mobile-nav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }